var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.29,
    height: 16.479,
    viewBox: "0 0 20.29 16.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter",
    transform: "translate(-120.162 -1001.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter",
    "data-name": "Icon awesome-twitter",
    d: "M18.2,7.488c.013.18.013.361.013.541A11.751,11.751,0,0,1,6.386,19.86,11.751,11.751,0,0,1,0,17.993a8.6,8.6,0,0,0,1,.051,8.328,8.328,0,0,0,5.163-1.777,4.166,4.166,0,0,1-3.888-2.884,5.244,5.244,0,0,0,.785.064,4.4,4.4,0,0,0,1.094-.142A4.159,4.159,0,0,1,.824,9.226V9.174A4.188,4.188,0,0,0,2.7,9.7,4.165,4.165,0,0,1,1.416,4.14,11.82,11.82,0,0,0,9.991,8.492a4.694,4.694,0,0,1-.1-.953,4.162,4.162,0,0,1,7.2-2.845,8.187,8.187,0,0,0,2.639-1A4.147,4.147,0,0,1,17.9,5.981a8.337,8.337,0,0,0,2.395-.644A8.939,8.939,0,0,1,18.2,7.488Z",
    transform: "translate(120.162 998.38)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b8e6fa2c73d3ab2588fdfacdb21eeec1.svg";
export { ForwardRef as ReactComponent };